export default __webpack_public_path__ + "media/images/react_icons/casatb/casatb_icon-65cb0f9599edec9d4ac43782026fcf07.svg";